import AppSuggestion from './AppSuggestion'
import DisabledOrderingWarning from './DisabledOrderingAlert'
import DisabledPushWarning from './DisabledPushAlert'
import OfflineWarning from './OfflineAlert'

export default function FixedWarnings() {
	return <>
		<DisabledOrderingWarning/>
		<OfflineWarning/>
		<DisabledPushWarning/>
		<AppSuggestion/>
	</>
}
